import clsx from 'clsx';
import React, { FC } from 'react';
import './PlannerFilterButton.scss';

export const FilterButton: FC<{
  title: string;
  disabled?: boolean;
  hoverTitle?: string;
  loading?: boolean;
  style?: React.CSSProperties;
  onClick: () => void;
}> = ({ title, disabled, loading, style, hoverTitle, onClick }) => {
  return (
    <button
      title={hoverTitle}
      onClick={onClick}
      disabled={disabled}
      className={clsx(
        'planner-filter-button',
        loading && 'gradient-fade-loading'
      )}
      style={style}
    >
      {title}
    </button>
  );
};
